/**
 * Maps a POS order status to a semantic Badge variant, so the Transaction
 * History and Time Logs tables render status the same way (and the same way as
 * the admin Orders screen): success = done, warning = needs action, destructive
 * = money reversed, muted = neutral/closed.
 */
export function posStatusVariant(status: string): 'success' | 'warning' | 'destructive' | 'muted' {
  switch (status) {
    case 'completed':
      return 'success';
    case 'to_release':
      return 'warning';
    case 'refunded':
      return 'destructive';
    default:
      return 'muted';
  }
}
